import { Link, useLocation, useNavigate } from 'react-router-dom';
import CampaignCardMobile from '../components/campaign-card-mobile';
import { connect, useSelector } from 'react-redux';
import React, { useState } from 'react';
import useBodyClass from '../../../hooks/useBodyClass';
import { ImShare } from 'react-icons/im';
import MaterialSymbol from '../../../components/icons/material-symbol';
import CampaignDetailMobileDrawer from '../components/CampaignDetailMobileDrawer';
import { ListService, PublicService } from '../../../core/services';
import { SwipeableDrawer, useMediaQuery } from '@mui/material';
import { isMobile, isTablet, isBrowser } from 'react-device-detect';
import { Loading, SelectedCampaign, UserLogin } from '../../../redux/action';
const publicService: PublicService = new PublicService();
const listService = new ListService();
interface Props {
  sm_id?: any;
    UserReducer?: any;
}
const InvitedCampaigns : React.FC<Props> = (props: Props) => {
  const navigate = useNavigate();
  const location = useLocation();

    const [loading, setLoading] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState<any>(null);
const [applyRestrictionPopup, setApplyRestrictionPopup] =
  useState(false);

const [applyRestrictionData, setApplyRestrictionData] =
  useState<any>(null);

const [checkInfType, setCheckInfType] = useState({
  status: false,
});

const [openCampaignDetailPopup, setOpenCampaignDetailPopup] =
  useState(false);

const [campaignDetailDrawerContent, setCampaignDetailDrawerContent] =
  useState<any>(null);

const [campaign_id, setCampaign_id] = useState<any>({
  campaign_id: null,
  campaign_platform: '',
});

const [btnName, setBtnName] = useState('Apply');
const isMobileDevice = useMediaQuery('(max-width:767px)');
const handleCampaignDetailPopup = async (campaign: any) => {
  setLoading(true);

  try {
    const response:any = await publicService.influencerCampaignDetail(
      null,
      campaign.campaign_id + '',
      props.sm_id || 0,
      'mobile'
    );
    if (response?.data?.rows) {
      setCampaign_id({
        campaign_id: campaign.campaign_id,
        campaign_platform: campaign.campaign_platform,
      });

      setCampaignDetailDrawerContent(response);
      setOpenCampaignDetailPopup(true);
    }
  } finally {
    setLoading(false);
  }
};

 const iOS =
  typeof navigator !== 'undefined' &&
  /iPad|iPhone|iPod/.test(navigator.userAgent);
const invitedCampaigns = React.useMemo(
  () =>
    ((location.state as {
      invitedCampaigns?: any[];
    })?.invitedCampaigns || []),
  [location.state]
);
const handleClickShare = (
  event: React.MouseEvent,
  campaign: any
) => {
  event.stopPropagation();

  if (navigator.share) {
    navigator.share({
      title: campaign?.data?.rows?.campaign_title,
      text: campaign?.data?.rows?.campaign_title,
      url: window.location.href,
    });
  }
};
const handleCampaignApply = async () => {
  try {
    if (btnName === 'Applied') {
      const response: any = await listService.getAppliedSm_id({
        influencerId: props?.UserReducer?.influencer_id,
        campaign_id:
          campaignDetailDrawerContent?.data?.rows?.campaign_id,
      });

      if (
        response?.status &&
        response?.data?.length > 0
      ) {
        navigate(
          `/influencer/campaign/proposal?campaignId=${
            campaignDetailDrawerContent?.data?.rows?.campaign_id
          }&smId=${response.data[0].sm_id || 0}`
        );

        setOpenCampaignDetailPopup(false);
      }
    } else {
      const res = await listService.getApplyRestriction({
        influencerId:
          props?.UserReducer?.influencer_id,
        platform:
          campaign_id?.campaign_platform,
        smId: props.sm_id || 0,
        campaignId:
          campaign_id?.campaign_id,
        accountId:
          props?.UserReducer?.account_id,
      });

      if (res?.status) {
        setApplyRestrictionData(res.data);

        if (
          res.data?.followers?.status &&
          res.data?.subscription?.status &&
          res.data?.social_connect?.status
        ) {
          if (res.data?.checkInfType?.status) {
            navigate(
              `/influencer/campaign/proposal?campaignId=${
                campaign_id?.campaign_id
              }&smId=${res.data?.sm_id}`
            );

            setOpenCampaignDetailPopup(false);
          } else {
            setCheckInfType({
              status: true,
            });
          }
        } else {
          setApplyRestrictionPopup(true);
        }
      }
    }
  } catch (err) {
    console.log(
      'error in handleCampaignApply',
      err
    );
  }
};

  useBodyClass('page-invited-campaigns')
    useBodyClass('my-campaign-detail-page')
  useBodyClass('influencer-app')
  const handleCampaignDetailPopupClose = () => {
  setOpenCampaignDetailPopup(false);
};

  return (
    <>
    <div className="invited-page">

              <div className="mobile-header d-md-none">
                <Link to="/influencer/mycampaigns">
                  <MaterialSymbol iconName="chevron_left" fontweight="400" fontSize="24px" />
                </Link>
                <span className="fw-semibold text-[16px] mx-auto"> Invited Campaigns</span>
             
              </div>
  

      {/* <div className="invited-list">
        {invitedCampaigns.map((campaign: any) => (
          <CampaignCardMobile
            key={campaign.campaign_id}
            data={campaign}
            loading={false}
            isMobile={true}
            campaign_id={campaign.campaign_id}
            onClick={() => setSelectedCampaign(campaign)}
          />
        ))}
      </div> */}
    {!openCampaignDetailPopup && (
  <div className="invited-list">
    {invitedCampaigns.map((campaign: any) => (
      <CampaignCardMobile
        key={campaign.campaign_id}
        data={campaign}
        loading={false}
        isMobile={true}
        campaign_id={campaign.campaign_id}
        onClick={() => handleCampaignDetailPopup(campaign)}
      />
    ))}
  </div>
    )}

      
    </div>
    {openCampaignDetailPopup && (
      <SwipeableDrawer
            id={`selected-campaign-${campaign_id.campaign_id}`}
            // anchor={drawerAnchor}
            anchor={isMobile ? 'bottom' : 'right'}
            open={openCampaignDetailPopup}
            onClose={handleCampaignDetailPopupClose}
            onOpen={handleCampaignDetailPopup}
            transitionDuration={300}
            className='popup-drawer drawer-infl-dashboard'
            disableSwipeToOpen={true}
            disableBackdropTransition={!iOS}
            disableDiscovery={iOS}
            hysteresis={0}
            ModalProps={{
              keepMounted: false,
            }}
          >
            {isMobileDevice && (
  <CampaignDetailMobileDrawer
    data={campaignDetailDrawerContent}
    loading={false}
    handleCampaignApply={handleCampaignApply}
    handleClickShare={handleClickShare}
    handleCampaignDetailPopupClose={
      handleCampaignDetailPopupClose
    }
    campaign_id={campaign_id.campaign_id}
    btnName={btnName}
  />
            )}
            </SwipeableDrawer>
)}
</>
  );
};

const mapStateToProps = (state: any) => {
  return {
    UserReducer: state.UserReducer.UserData,
    UserID: state.UserID.userID,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
    selectedInf: (data: any) => dispatch(SelectedCampaign(data)),
    updateUser: (data: any) => dispatch(UserLogin(data)),
  };
};

const connectToRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(InvitedCampaigns);

export { connectToRedux as InvitedCampaigns };